import React, { useMemo } from 'react';
import { HelpText, IHelpText } from '../../../../../../components/helptext';

export function ChangeJobcenterHelpTextMenu({ texts = [] }: { texts?: IHelpText[] }) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => (texts.length ? <HelpText helpText={texts} showDetailsWithBullets /> : null), [texts]);
}
